import { useRef } from 'react';

export function useLessonCache() {
  const cache = useRef({});

  const get = (topicKey, subtopic) =>
    cache.current[`${topicKey}::${subtopic}`] || null;

  const set = (topicKey, subtopic, data) => {
    cache.current[`${topicKey}::${subtopic}`] = data;
  };

  const clear = (topicKey, subtopic) => {
    delete cache.current[`${topicKey}::${subtopic}`];
  };

  return { get, set, clear };
}
